<div class="title mb-4">
  <h2>Members Analytics</h2>
</div>

<div class="row">
  <div class="col-lg-12 col-md-12">
    <div class="white_box shadow p-3">
      <!-- Cards -->
      <div class="row mt-3">
        <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
          <div class="card pt-3 text-center">
            <i class="doller_icon mx-auto d-flex align-items-center justify-content-center fa fa-users"
              style="font-size: 4rem" caria-hidden="true"></i>
            <h3>Total Members</h3>
            <p style="font-size: 2rem">{{ totalMembers?.length || 0 }}</p>
            <span class="save_info bg-transparent"> </span>
          </div>
        </div>

        <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
          <div class="card pt-3 text-center">
            <i class="doller_icon mx-auto d-flex align-items-center justify-content-center fa fa-male"
              style="font-size: 4rem" caria-hidden="true"></i>
            <h3>Total Active Users</h3>
            <p style="font-size: 2rem">{{ totalActiveUsers }}</p>
            <span class="save_info bg-transparent"> </span>
          </div>
        </div>

        <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
          <div class="card pt-3 text-center">
            <i class="doller_icon mx-auto d-flex align-items-center justify-content-center fa fa-bullhorn"
              style="font-size: 4rem" caria-hidden="true"></i>
            <h3>Total Referrals</h3>
            <p style="font-size: 2rem">{{ totalReferrals }}</p>
            <span class="save_info bg-transparent"> </span>
          </div>
        </div>
      </div>
      <!-- Cards -->
      <form>
        <div class="mb-3 row mt-5">
          <!-- <label for="table-filtering-search" class="col-xs-3 col-sm-auto col-form-label">Full text search:</label> -->
          <div class="col-xs-3 col-sm-auto">
            <div class="input-group">
              <input id="table-filtering-search" class="form-control" type="text" [formControl]="searchText"
                placeholder="Search" (keyup)="search($event.target.value)" />
              <button type="button" *ngIf="searchText.value" (click)="clearSearch('searchText')"
                class="btn bg-transparent" style="margin-left: -40px; z-index: 100">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group">
              <input type="text" class="form-control" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3"
                [formControl]="searchDate" [selectMode]="'range'" placeholder="Search By Date" />
              <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="searchByDate()" #dt3></owl-date-time>
              <button type="button" *ngIf="searchDate.value" (click)="clearSearch()" class="btn bg-transparent"
                style="margin-left: -40px; z-index: 100">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
      <!-- Table -->
      <section>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" sortable="phone" (click)="onSort($event)">
                  Member
                </th>
                <th scope="col" sortable="profileCharacterName" (click)="onSort($event)">
                  Name
                </th>
                <th scope="col" sortable="level" (sort)="onSort($event)">
                  Is Verified
                </th>
                <th scope="col" sortable="level" (sort)="onSort($event)">
                  Level
                </th>
                <th scope="col" sortable="status" (sort)="onSort($event)">
                  Status
                </th>
                <th scope="col" sortable="lastLoginTime" (sort)="onSort($event)">
                  Last Login Time
                </th>
                <th scope="col" sortable="totalActiveTime" (sort)="onSort($event)">
                  Total Active time
                </th>
                <th scope="col" sortable="noOfTimeLogin" (sort)="onSort($event)">
                  No. of Time Login
                </th>
                <th scope="col" sortable="noOfReferrals" (sort)="onSort($event)">
                  No. of Referrals
                </th>
                <th scope="col" sortable="noSuggestions" (sort)="onSort($event)">
                  No. Suggestions
                </th>
                <th scope="col" sortable="noReports" (sort)="onSort($event)">
                  No. Reports
                </th>
                <th scope="col" sortable="noForumPosts" (sort)="onSort($event)">
                  No. Forum Posts
                </th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let member of members; index as i">
                <tr *ngIf="members.length > 0">
                  <th scope="row">{{ (page - 1) * pageSize + i + 1 }}</th>
                  <td>
                    <a style="color: #009dff">{{ member?.phone }}</a>
                  </td>
                  <td>{{ member?.profileCharacterName }}</td>
                  <td>
                    <a style="color: #009dff">{{
                      member?.isVerified ? "Yes" : "No"
                      }}</a>
                  </td>
                  <td>{{ member?.level || 0 }}</td>
                  <td class="text-nowrap">
                    <i class="fa fa-circle" [style.color]="
                        member?.status == 1 ? '#09a0ff' : 'red'
                      " aria-hidden="true"></i>
                    {{ member?.status == 1 ? "Active" : "Inactive" }}
                  </td>
                  <td>{{ member?.lastLoginTime | date : "dd/MM/yyyy" }}</td>
                  <td>{{ member?.totalSessionTimeInHr + " Hours" }}</td>
                  <td>{{ member?.noOfTimeLogin }}</td>
                  <td>{{ member?.noOfReferrals || 0 }}</td>
                  <td>{{ member?.suggestions }}</td>
                  <td>{{ member?.reports }}</td>
                  <td>{{ member?.noForumPosts || 0 }}</td>
                  <td>
                    <div class="btn-group">
                      <button class="btn btn-{{ member?.status == 0 ? 'secondary' : 'success' }} btn-sm" (click)="
                        disableEnableUser(
                          member?.id,
                          member?.status == 0 ? 1 : 0
                        )
                      ">
                        <i class="fa" [ngClass]="member?.status == 0 ? 'fa-check' : 'fa-times'"></i>
                        {{ member?.status == 0 ? " Enable" : " Disable" }}
                      </button>
                      <button class="btn btn-{{ !member?.isBlocked ? 'secondary' : 'danger' }} btn-sm" (click)="
                        blockProfile(
                          member?.id
                        )
                      ">
                        <i class="fa" [ngClass]="!member?.isBlocked ? 'fa-ban' : 'fa-unlock'"></i>
                        {{ !member?.isBlocked ? " Block" : " Unblock" }}
                      </button>
                      <button class="btn btn-danger btn-sm" (click)="
                        deleteProfile(
                          member?.id
                        )
                      ">
                        <i class="fa fa-trash"></i>
                        Delete
                      </button>
                      <button class="btn btn-info btn-sm" (click)="
                        tasks(
                          member?.referralCode
                        )
                      ">
                        <i class="fa fa-tasks"></i>
                        Tasks
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-container>

              <tr *ngIf="members.length == 0">
                <td colspan="12" style="text-align: center">No Data</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between p-2">
          <ngb-pagination [collectionSize]="totalMembers.length" [(page)]="page" [pageSize]="pageSize"
            (pageChange)="nextPage()">
          </ngb-pagination>

          <select class="form-select" style="width: auto" [(ngModel)]="pageSize" (ngModelChange)="nextPage()">
            <option [ngValue]="10">10 items per page</option>
            <option [ngValue]="20">20 items per page</option>
            <option [ngValue]="30">30 items per page</option>
          </select>
        </div>
      </section>
      <!-- Table -->
    </div>
  </div>
</div>